<div class="text-gray-50 mb-5 mt-3 ml-5 md:mt-0">
  @if (stationsCount() === 0) {
    <p>{{ 'noLocationsFound' | translate }}</p>
  } @else {
    <p>{{ stationsCount() }} {{ 'locationsFound' | translate }}</p>
  }
</div>
